import liveCheckReducerMap from 'wanderu-ducks-live-check';
import psearchReducerMap from 'wanderu-ducks-psearch';
import seoReducerMap from 'wanderu-ducks-seo';

import CityToCity from '../containers/CityToCity/CityToCity';

function onLoad(module, info, props, context) {
    context.store.inject({
        ...liveCheckReducerMap,
        ...seoReducerMap,
        ...psearchReducerMap,
    });
}

export { onLoad };
export default CityToCity;
